import { combineReducers } from "redux";
import TimpreReducer from "./accountReducers";

const reducerCombiner = combineReducers({
    account: TimpreReducer
});

export default reducerCombiner;

export type RootState = ReturnType<typeof reducerCombiner>;